/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * Convert the provided date string provided format.
 *
 * @param {string} date
 * @param {string} format
 *
 * @return {mixed}
 */
export const dateToFormat = (date, format = 'DD/MM/YYYY') => {
  const dateStr = dayjs(date).format(format);
  return dateStr === 'Invalid Date' ? false : dateStr;
};
